import React from 'react';
import styles from './ErrorContentDialog.less';
import { Button } from '@trello/nachos/button';
import { constants } from './constants';
import { ErrorHandlerProps } from 'app/src/components/ErrorBoundary';

export interface ErrorContentDialog extends ErrorHandlerProps {
  handleClick?: () => void;
}

export const ErrorContentDialog: React.FC<ErrorContentDialog> = ({
  handleClick,
}) => {
  return (
    <div className={styles.container}>
      <img
        alt=""
        role="presentation"
        className={styles.modalImage}
        src={require('resources/images/request-access/generic-error.svg')}
      />
      <h1 className={styles.modalTitle}>{constants.ERROR_CONTENT_TITLE}</h1>
      <p className={styles.modalText}>{constants.ERROR_CONTENT_TEXT}</p>
      <Button
        className={styles.modalImageButton}
        size="fullwidth"
        appearance="primary"
        onClick={handleClick}
      >
        {constants.INVITE_ERROR_BUTTON_TEXT}
      </Button>
    </div>
  );
};
